module.exports = __webpack_public_path__ + "static/media/dummyMaterial.77e00b15.png";